module.exports = __webpack_public_path__ + "img/banco-de-mexico.2aa2ff34.svg";